import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';

import { DsButton } from '@frontend/ui/button';
import { DsCard, DsCardContent } from '@frontend/ui/card';
import { DsDivider } from '@frontend/ui/divider';
import { DsTooltipModule } from '@frontend/ui/tooltip';
import {
    CurrencyPipe,
    DslService,
    DynamicComponentDirective,
    DynamicHtmlDirective,
    NavigationService,
    ProductHomepagesConfig,
} from '@frontend/vanilla/core';
import { AccountMenuRouter } from '@frontend/vanilla/shared/account-menu';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { AccountMenuItemBase } from '../../account-menu-item-base';

@Component({
    standalone: true,
    imports: [
        CommonModule,
        DsButton,
        DsCard,
        DsCardContent,
        DsDivider,
        CurrencyPipe,
        DynamicHtmlDirective,
        DynamicComponentDirective,
        IconCustomComponent,
        DsTooltipModule,
    ],
    selector: 'vn-wallet-balance-item',
    templateUrl: './wallet-balance-item.html',
    providers: [AccountMenuRouter],
    styleUrls: ['../../../../../../../themepark/themes/whitelabel/components/wallet/wallet-balance-item/styles.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class WalletBalanceItemComponent extends AccountMenuItemBase implements OnInit {
    balance: number;
    private readonly navigation = inject(NavigationService);
    private readonly productHomepages = inject(ProductHomepagesConfig);
    private dslService = inject(DslService);

    ngOnInit(): void {
        const formula = this.item?.parameters['formula'];
        if (formula) {
            this.dslService.evaluateExpression<number>(formula).subscribe((x) => (this.balance = x));
        }
    }

    goToCustomerCare() {
        this.navigation.goTo(this.productHomepages.portal + '/myaccount/contact');
    }
}
